// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","body":"_2lYHSCAcM6vA2s-47YYZeS","dropdown":"_2kzr3YmNovNTPVDq61hh3E","option":"_10BsS2wlpOxBL9cO_jIrCL _2lYHSCAcM6vA2s-47YYZeS","selected":"_2oZTL0zzzW838--VsJk_OJ _2lYHSCAcM6vA2s-47YYZeS"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/search/sort-select/SortSelect.css
// module id = 1074
// module chunks = 1